<div class="link">
    <a *ngIf="url != ''" [href]="url">
        <span>{{content}}</span>
    </a>
    <a *ngIf="url == ''">
        {{content}}
    </a>
    <div class="underline"></div>
</div>